import { useI18n } from "vue-i18n";
import { computed } from "vue";

export function useFieldConfig() {
    const { t } = useI18n();

    // Common translations
    const translations = computed(() => ({
        // Basic fields
        title: t("page.block.fields.title"),
        description: t("page.block.fields.description"),
        tag: t("page.block.fields.tag"),
        text: t("page.block.fields.text"),
        label: t("page.block.fields.label"),
        placeholder: t("page.block.fields.placeholder"),
        href: t("page.block.fields.href"),
        urlLabel: t("page.block.fields.urlLabel"),
        type: t("page.block.fields.type"),
        buttonText: t("page.block.fields.buttonText"),
        hookUrl: t("page.block.fields.hookUrl"),

        // Image related
        image: t("page.block.fields.image"),
        video: t("page.block.fields.video"),
        media: t("page.block.media"),
        alt: t("page.block.fields.alt"),
        src: t("page.block.fields.src"),
        mediaType: t("page.block.fields.mediaType"),
        videoSrc: t("page.block.fields.videoSrc"),
        videoAutoplay: t("page.block.fields.videoAutoplay"),
        videoControls: t("page.block.fields.videoControls"),
        videoLoop: t("page.block.fields.videoLoop"),
        iframeSrc: t("page.block.fields.iframeSrc"),
        backgroundImage: t("page.block.fields.backgroundImage"),
        backgroundImageTransparency: t("page.block.fields.backgroundImageTransparency"),
        iconSrc: t("page.block.fields.iconSrc"),
        mainImage: t("page.block.fields.mainImage"),
        secondaryImage: t("page.block.fields.secondaryImage"),
        // Button related
        primaryButton: t("page.block.fields.primaryButton"),
        secondaryButton: t("page.block.fields.secondaryButton"),
        primaryButtonLabel: t("page.block.fields.primaryButtonLabel"),
        secondaryButtonLabel: t("page.block.fields.secondaryButtonLabel"),
        primaryButtonHref: t("page.block.fields.primaryButtonHref"),
        secondaryButtonHref: t("page.block.fields.secondaryButtonHref"),
        submitButton: t("page.block.fields.submitButton"),
        button: t("page.block.fields.button"),
        callToActionButton: t("page.block.fields.callToActionButton"),

        // Form related
        field: t("page.block.fields.field"),
        inputName: t("page.block.fields.inputName"),
        isRequired: t("page.block.fields.isRequired"),
        fieldType_text: t("page.block.fields.fieldType_text"),
        fieldType_textarea: t("page.block.fields.fieldType_textarea"),
        fieldType_email: t("page.block.fields.fieldType_email"),
        fieldType_tel: t("page.block.fields.fieldType_tel"),
        spanFull: t("page.block.fields.spanFull"),
        privacyPolicy: t("page.block.fields.privacyPolicy"),
        validationMessage: t("page.block.fields.validationMessage"),
        successMessage: t("page.block.fields.successMessage"),
        errorMessage: t("page.block.fields.errorMessage"),

        // Team member related
        member: t("page.block.fields.member"),
        name: t("page.block.fields.name"),
        role: t("page.block.fields.role"),
        linkedInLink: t("page.block.fields.linkedInLink"),
        xLink: t("page.block.fields.xLink"),

        // Stats related
        stats: t("page.block.fields.stats"),
        stat: t("page.block.fields.stat"),
        firstStat: t("page.block.fields.firstStat"),
        secondStat: t("page.block.fields.secondStat"),
        thirdStat: t("page.block.fields.thirdStat"),
        events: t("page.block.fields.events"),
        event: t("page.block.fields.event"),
        date: t("page.block.fields.date"),

        // Feature related
        features: t("page.block.fields.features"),
        feature: t("page.block.fields.feature"),
        linkHref: t("page.block.fields.linkHref"),
        linkLabel: t("page.block.fields.linkLabel"),
        authorIcon: t("page.block.fields.authorIcon"),
        authorName: t("page.block.fields.authorName"),
        authorPosition: t("page.block.fields.authorPosition"),

        // Tabs related
        tabs: t("page.block.fields.tabs"),
        tab: t("page.block.fields.tab"),

        // Navigation related
        navigateTo: t("page.block.fields.navigateTo"),
        item: t("page.block.fields.item"),
        logo: t("page.block.fields.logo"),

        // Other common fields
        callToAction: t("page.block.fields.callToAction"),
        secondaryTitle: t("page.block.fields.secondaryTitle"),
        secondaryDescription: t("page.block.fields.secondaryDescription"),
        topText: t("page.block.fields.topText"),
        bottomText: t("page.block.fields.bottomText"),
        paragraph: t("page.block.fields.paragraph"),
        subtitle: t("page.block.fields.subtitle"),
        topLabel: t("page.block.fields.topLabel"),
        testimonial: t("page.block.fields.testimonial"),
        listItem: t("page.block.fields.listItem"),
        cell: t("page.block.fields.cell"),
        socialProofText: t("page.block.fields.socialProofText"),
        detail: t("page.block.fields.detail"),
        contact: t("page.block.fields.contact"),
        email: t("page.block.fields.email"),
        phone: t("page.block.fields.phone"),
        city: t("page.block.fields.city"),
        address: t("page.block.fields.address"),
        addressLine1: t("page.block.fields.addressLine1"),
        addressLine2: t("page.block.fields.addressLine2"),
        position: t("page.block.fields.position"),
        location: t("page.block.fields.location"),
        secondaryDescriptionOne: t("page.block.fields.secondaryDescriptionOne"),
        secondaryDescriptionTwo: t("page.block.fields.secondaryDescriptionTwo"),
        infoNote: t("page.block.fields.infoNote"),
        tertiaryTitle: t("page.block.fields.tertiaryTitle"),
        tertiaryDescriptionOne: t("page.block.fields.tertiaryDescriptionOne"),
        tertiaryDescriptionTwo: t("page.block.fields.tertiaryDescriptionTwo"),
        statsTitle: t("page.block.fields.statsTitle"),

        // Elements related
        heading: t("page.block.fields.heading"),
        items: t("page.block.fields.items"),
        formatting: t("page.block.formatting"),
        textSize: t("page.block.fields.textSize"),
        textAlign: t("page.block.fields.textAlign"),
        maxWidth: t("page.block.fields.maxWidth"),
        elementAlign: t("page.block.fields.elementAlign"),
        paddingTop: t("page.block.fields.paddingTop"),
        paddingBottom: t("page.block.fields.paddingBottom"),
        justifyContent: t("page.block.fields.justifyContent"),
        markdown: t("page.block.fields.markdown"),
        iframeHeight: t("page.block.fields.iframeHeight"),
    }));

    return {
        translations,
    };
}
